import { IconType } from "react-icons/lib";
import { TbCar, TbHeartHandshake, TbHospital, TbPasswordUser } from "react-icons/tb";

import { UserType } from "@/types/user.types";

import { softColors } from "./colors";
import { PERMISSION_IDS } from "./permissions";

export type UserTypeItem = {
    component: () => IconType;
    hover: string;
    bg: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
    values: UserType[];
    value: UserType;
    getLabel: (type: UserType) => string;
    show: boolean;
    hideOnCreateNotification?: boolean;
    permissionId: string[];
};

export type UserTypeList = UserTypeItem[];

export const userTypes: UserTypeList = [
    {
        getLabel: () => "Şoför",
        component: () => TbCar,
        ...softColors.green,
        tooltip: {
            title: "Şoför",
            description: "Ulaşım ve taşıma işlemlerinden sorumlu kullanıcı.",
        },
        values: [UserType.DRIVER],
        value: UserType.DRIVER,
        show: true,
        permissionId: PERMISSION_IDS[UserType.DRIVER],
    },
    {
        getLabel: () => "Karşılama Ekibi",
        component: () => TbHeartHandshake,
        ...softColors.blue,
        tooltip: {
            title: "Karşılama Ekibi üyesi",
            description: "Gelenleri karşılayan ve yönlendiren ekip üyesi.",
        },
        values: [UserType.WELCOME_TEAM_OFFICER],
        value: UserType.WELCOME_TEAM_OFFICER,
        show: true,
        permissionId: PERMISSION_IDS[UserType.WELCOME_TEAM_OFFICER],
    },
    {
        getLabel: (type) => "userTypeLabels." + type,
        component: () => TbPasswordUser,
        ...softColors.purple,
        tooltip: {
            title: "Yönetici",
            description: "Operasyonları yöneten ve ekibi denetleyen kullanıcı.",
        },
        values: [UserType.MANAGER, UserType.HR, UserType.ADMIN],
        value: UserType.MANAGER,
        show: true,
        permissionId: PERMISSION_IDS[UserType.MANAGER],
    },
    {
        getLabel: (type) => "userTypeLabels." + type,
        component: () => TbPasswordUser,
        ...softColors.purple,
        tooltip: {
            title: "İnsan Kaynakları",
            description: "Operasyonları yöneten ve ekibi denetleyen kullanıcı.",
        },
        values: [UserType.HR],
        value: UserType.HR,
        show: false,
        permissionId: PERMISSION_IDS[UserType.HR],
    },
    {
        getLabel: (type) => "userTypeLabels." + type,
        component: () => TbPasswordUser,
        ...softColors.purple,
        tooltip: {
            title: "Departman Yöneticisi",
            description: "Operasyonları yöneten ve ekibi denetleyen kullanıcı.",
        },
        values: [UserType.ADMIN],
        value: UserType.ADMIN,
        show: false,
        permissionId: PERMISSION_IDS[UserType.ADMIN],
    },
    {
        getLabel: (type) => "userTypeLabels." + type,
        component: () => TbHospital,
        ...softColors.indigo,
        tooltip: {
            title: "Klinik",
            description: "Klinik işlemlerinden sorumlu kullanıcı.",
        },
        values: [UserType.KLINIK],
        value: UserType.KLINIK,
        show: false,
        permissionId: PERMISSION_IDS[UserType.KLINIK],
        hideOnCreateNotification: true,
    },
];
